import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getTopCus } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";

const Top5Cus = () => {
  const [customersData, setCustomersData] = useState([]);
  const [showStatus, setShowStatus] = useState(true)

  useEffect(() => {
    getTopCus().then((res) => {
      if (res.status) {
        setCustomersData(res.data);
        setShowStatus(true)
      } else {
        setCustomersData([]);
        setShowStatus(false)
      }
    });
  }, []);
  const xAxisData = customersData?.map(
    (customer) => customer.entity.entity_name
  )
  if(xAxisData.length<6){
    xAxisData.push(" ")
  }

  const options = {
    toolbar: {
      show: true,
      tools: {
        download: false,
      },
    },
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        endingShape: "flat",
        barHeight: "50%",
        columnWidth: "50%",
        borderRadius: 0,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "#34c38f";
          case 1:
            return "#3f9ae5";
          case 2:
            return "#f46a6a";
          case 3:
            return "#f1b44c";
          case 4:
            return "#00c5dc";
          default:
            return "#0174BE";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Deals",
      },
      style: {
        fontSize: "16.5px",
        color: "#333",
        background: "transparent",
        maxWidth: 300,
        overflow: "ellipsis",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      categories: customersData?.map(
        (customer) => customer.entity.entity_name
      ),
      categories: xAxisData,
    },
    yaxis: {},
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " deals";
        },
      },
    },
  };

  const series = [
    {
      name: "",
      data: customersData?.map((customer) => parseInt(customer.dealCount)),
    },
  ];

  return (
    <Card>
      {showStatus ? <CardBody>
        <h4 className="card-title mb-2">Top 5 Customers</h4>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          className="mb-2"
        >
        </div>
        <div style={{ maxWidth: "100%" }}>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={318}
          />
        </div>
      </CardBody>
        : <NoDataChart title='No Information Found' subtitle="No Customer has Created Deal" />}
    </Card>
  );
};

export default Top5Cus;
